import React from "react";
import Action from "./Action";
import Wordmark from "./Wordmark";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      style={{
        borderTop: "1px solid var(--line)",
        marginTop: "clamp(60px, 8vw, 100px)",
        padding: "clamp(32px, 5vw, 56px) clamp(20px, 5vw, 60px) 44px",
        background:
          "linear-gradient(180deg, transparent, rgba(0,0,0,0.35))",
      }}
    >
      <div
        style={{
          maxWidth: 1120,
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: 26,
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 24,
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <div style={{ maxWidth: 420 }}>
            <Wordmark compact />
            <p
              style={{
                color: "var(--text-dim)",
                marginTop: 14,
                fontSize: 14,
                lineHeight: 1.6,
              }}
            >
              Green Gold Energy Pvt. Ltd. · Tamil Nadu.
              <br />
              An integrated, native energy ecosystem for India's next two
              decades.
            </p>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              minWidth: 220,
            }}
          >
            <div className="gg-eyebrow">Contact</div>
            {/* TBD: confirm final contact email with the client before launch. */}
            <a
              href="mailto:hello@greengold.energy"
              className="gg-action"
              data-testid="footer-contact-email"
            >
              hello@greengold.energy
            </a>
          </div>
        </div>

        <div
          style={{
            padding: "20px 0 0",
            borderTop: "1px solid var(--line)",
            display: "flex",
            flexWrap: "wrap",
            gap: "18px 32px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              margin: 0,
              color: "var(--text-cloud)",
              fontSize: 14.5,
              lineHeight: 1.6,
              maxWidth: 640,
            }}
          >
            Two things are always open:{" "}
            <Action route="book-tour" source="footer">
              schedule a walk through the Tamil Nadu Factory
            </Action>
            , or{" "}
            <Action route="request-data-room" source="footer">
              request access to the SPV data room
            </Action>
            .
          </p>
          <p
            style={{
              margin: 0,
              color: "var(--text-mute)",
              fontSize: 12,
              letterSpacing: "0.06em",
            }}
          >
            © {new Date().getFullYear()} Green Gold Energy Pvt. Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
}
